export default class Menu {

    constructor()
    {
        Menu.initializeBurgerMenu();
    }

    static initializeBurgerMenu() {
        let more_menu   = '[data-more-menu]',
            item_menu   = '[data-item-menu]',
            return_menu = '[data-return-menu]',
            burger_menu = '[data-burger-menu]';

        $( document ).on( 'click', burger_menu, function ( e ) {
            $('body').toggleClass('menuOpen');
            $(this).toggleClass('open');
        } );

        $( document ).on( 'click', more_menu, function ( e ) {
            $( item_menu ).removeClass( 'submenuActive' );
            $( this ).next( item_menu ).addClass( 'submenuActive' );
        } );

        $( document ).on( 'click', return_menu, function ( e ) {
            $( this ).parents( item_menu ).removeClass( 'submenuActive' );
        } );
    }
}